import styled from 'styled-components';

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    color: #000;
    @media (min-width: 620px) {
        width: 300px;
    }
`;

export const Icon = styled.div`
    width: 49px;
    height: 75px;
    font-family: 'Icomoon';
    font-size: 50px;
    color: #404040;
`;

export const Title = styled.p`
    margin: 0;
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 1.79;
`;

export const Description = styled(Title)`
    margin: 0;
    text-align: center;
    font-size: 14px;
    line-height: 1.79;
    max-width: 290px;
    a {
        color: #1e81d6;
    }
`;
